

export const getTilesData = (data) => {

    const preSelectedBackground = Array.isArray(data?.images) && data?.images.find(element => element.preselected);
    let videoURL = data?.images?.[0]?.videoURL || ""
    const tilesList = data?.category || [];
    const userData = data?.user || {};
    const tilePolicyId = data?.tilePolicyId || "";

    return { preSelectedBackground, videoURL, tilesList, userData, tilePolicyId };

}